"use client";
// @ts-strict-ignore
import React, { useState } from "react";
import { useTranslations } from "i18n";
import styled from "styled-components";
import {
  LegalHeadingWrapper,
  OptionCard,
  Line,
  CardsColDesktop,
  LegalItem,
  ItemsCol
} from "components/modules/FeesLegal/style";
import HoverUnderline from "components/parts/HoverUnderline";
import { ContentContainer } from "components/layout/Layout";
import { Grid, Row } from "components/layout/Grid";
import { Body, Heading } from "components/parts/Typography";

import RightCaret from "public/static/images/right-caret.svg";
import Picture from "components/parts/Picture";
import NextLink from "components/parts/NextLink";
import type { LegalPageProps } from "types/legal";
import Dropdown from "components/modules/Dropdown";
import { MobileContent } from "./LegalSlug/style";
import { FILES } from "i18n/constants";

const StyledContentContainer = styled(ContentContainer)`
  min-height: 1048px;
`;

const Legal = ({ allArticles, isDerivatives }: LegalPageProps) => {
  const t = useTranslations(FILES.LEGAL);
  const [option, setOption] = useState(allArticles[0].type || "");
  const [activeHover, setActiveHover] = useState(null);
  const selectOption = (e, option) => {
    e.preventDefault();
    setOption(option);
  };
  const selectedArticles =
    allArticles.find(({ type }) => type === option)?.legalArticles || [];
  const [articleTypes, setArticleTypes] = React.useState(
    allArticles.map(({ type }) => type)
  );

  const setFirstOption = (options, index, setType) => {
    const temporalOptions = [...options];
    temporalOptions.unshift(temporalOptions[index]);
    temporalOptions.splice(index + 1, 1);
    setType(temporalOptions);
    setOption(temporalOptions[0]);
    return temporalOptions;
  };

  React.useEffect(() => {
    const index = articleTypes.findIndex((type) => type === option);
    setFirstOption(articleTypes, index, setArticleTypes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [option]);

  return (
    <StyledContentContainer>
      <Grid>
        <MobileContent>
          <Dropdown
            inputOptions={articleTypes}
            setFirst={setFirstOption}
            setOption={setArticleTypes}
            setFirstOptBold={true}
          />
        </MobileContent>
        <LegalHeadingWrapper>
          <Heading
            as="h1"
            size="xl"
            sm={{ mb: "16px" }}
            md={{ mb: "12px" }}
            lg={{ mb: "8px" }}
          >
            {isDerivatives ? "Gemini Crypto Derivatives Legal" : t("pageTitle")}
          </Heading>
        </LegalHeadingWrapper>
        <Row css={{ marginTop: 0, marginBottom: 0 }}>
          {!isDerivatives && (
            <CardsColDesktop sm={12} md={12} lg={4}>
              {allArticles.map((articleList, index) => (
                <OptionCard
                  onClick={(e) => selectOption(e, articleList.type)}
                  key={`${articleList.type}-${index}`}
                >
                  <Body size="md" semiBold={option === articleList.type}>
                    {articleList.type}
                  </Body>
                </OptionCard>
              ))}
            </CardsColDesktop>
          )}
          <ItemsCol
            sm={12}
            md={12}
            lg={isDerivatives ? 12 : 8}
            flexDirection="column"
          >
            {!isDerivatives && (
              <Heading
                size="md"
                lg={{ mb: "24px", display: "block" }}
                sm={{ display: "none" }}
              >
                {option}
              </Heading>
            )}
            <Line />
            {selectedArticles
              .filter(({ name, slug }) => name && slug)
              .map((item, i) => (
                <NextLink
                  href={
                    isDerivatives
                      ? `/artemis/legal/${item.slug}`
                      : `/legal/${item.slug}`
                  }
                  key={item.name}
                >
                  <LegalItem
                    onMouseEnter={() => setActiveHover(`${item.name}-${i}`)}
                    onMouseLeave={() => setActiveHover(null)}
                  >
                    <Body size="md" m="0">
                      <HoverUnderline
                        active={activeHover === `${item.name}-${i}`}
                      >
                        {item.name}
                      </HoverUnderline>
                      <Picture src={RightCaret.src} alt={t("iconAlt")} />
                    </Body>
                  </LegalItem>
                </NextLink>
              ))}
          </ItemsCol>
        </Row>
      </Grid>
    </StyledContentContainer>
  );
};
export default Legal;
